import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import InGameValueCard from "../InGameValueCard";
import {TENDER_RESEARCHES} from "../../../constants/Constants";

export default class TenderResearch extends React.Component {
  render() {
    let tender = this.props.tender;
    let client = TENDER_RESEARCHES[tender.order.client];

    let content = <div className={"tender-research__content"} style={{padding: "20px 10px 10px"}}>
      <InGameValueCard title={`Клиент: ${client.name}`} height={30} type={0} subtype={0}/>
      <InGameValueCard title={"Цена"} value={`${client.price}%`} height={30} type={1} subtype={1}/>
      <InGameValueCard title={"Подача клиенту порожних вагонов под погрузку на станции отправления (День недели)"}
                       className="bigTexts" value={`${client.loadDayWeight}%`} height={30} type={1} subtype={2}/>
      <InGameValueCard title={"Подача клиенту груженых вагонов под выгрузку на станции назначения (День недели)"}
                       className="bigTexts" value={`${client.unloadDayWeight}%`} height={30} type={1} subtype={1}/>
      <InGameValueCard title={"Индекс клиентоориентированности"} value={`${client.npsWeight}%`} height={30} type={1}
                       subtype={2}/>
      <InGameValueCard title={"Индекс накопленного опыта"} value={`${client.expWeight}%`} height={30} type={1}
                       subtype={1}/>
      <InGameValueCard title={"Кредит"} value={`${client.creditWeight}%`} height={30} type={1} subtype={2}/>
      <InGameValueCard title={"ИТОГО"} value={`100%`} height={30} type={1} subtype={0}/>
    </div>

    return <div className={"container__shadow tender-research"}>
      <div className="container__content">
        <GameWindowHeader width={540} height={40} onHide={this.props.onHide} isClosable={true}
                          title={"Относительная важность конкурентных факторов"}/>
        <GameWindowBg width={540} height={280} value={content}/>
      </div>
    </div>
  }
}
